
import { createActionGroup, createFeature, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { userActions } from './user.era';
import { eventsActions } from './events.era';
import { tasksActions } from './tasks.era';
import { listDifference } from 'globals/helpers/helpers';


const INIT_EVENT_PREFERENCES    = '[EventPreference] init state of event preferences';
const ADD_EVENT_PREFERENCES    = '[EventPreference] added from db';

export interface EventPreferenceDoc {
  createdAt?: Date;
  task_order:string[];
  updatedAt?: Date;
}

export interface EventPreferenceState {
  loading:boolean
  document:Partial<EventPreferenceDoc>
}

export const initialStateCreator = (): EventPreferenceState => ({
  loading: true,
  document:{task_order:[]}
})

// Actions
export const eventPreferencesActions = createActionGroup({
  source: 'EventPreference',
  events: {
    'Init Event Preferences': (is_loading:boolean = true) => ({ is_loading }),
    'Add Event Preferences': (payload: Partial<EventPreferenceDoc>) => ({ payload }),
  }
})

export const eventPreferencesReducer = createReducer(
  initialStateCreator(),
  on(userActions.logout, (state, action) => initialStateCreator()),
  on(eventsActions.unloadEvent, (state, action) => initialStateCreator()),
  on(eventPreferencesActions.initEventPreferences, (state, action) => {
    const init_state = initialStateCreator()
    init_state.loading = action.is_loading;
    return {...state, ...init_state}
  }),
  on(eventPreferencesActions.addEventPreferences, (state, action) => {
    return {...state, document: action.payload as Partial<EventPreferenceDoc>, loading:false}
  }),
  on(tasksActions.addManyTasks, (state, action) => {
    const missingIds = listDifference(action.payload.map(t => t.id), state.document.task_order)
    if (!missingIds.length) return state
    return { ...state, document: { ...state.document, task_order: [...missingIds, ...state.document.task_order ] }}
  }),
);

export const eventPreferenceFeature = createFeature({
  name: 'eventPreferences',
  reducer: eventPreferencesReducer,
});

export const eventPreferencesStateSelector = createFeatureSelector<EventPreferenceState>('eventPreferences');
